'use strict';
const angular = require('angular');

export default angular.module('appApp.pageintro', [])
  .directive('pageintro', function() {
    return {
      template: require('./pageintro.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/pageintro/pageintro.directive.js